import Vue from 'vue';
import VueRouter from 'vue-router';
import store from '../store/store';

Vue.use(VueRouter);

const routes = [
  {
    path: '/roi/calculator',
    name: 'roi-calculator',
    component: () => import(/* webpackChunkName: "roi calculator" */ '../views/RoiCalculator.vue'),
  },
  {
    path: '/order-to-pdf/:orderType/:id',
    name: 'order-to-pdf',
    component: () => import(/* webpackChunkName: "order to pdf" */ '../views/OrderToPdf.vue'),
  },
  {
    path: '/invoice-to-pdf/:id',
    name: 'invoice-to-pdf',
    component: () => import(/* webpackChunkName: "invoice to pdf" */ '../views/InvoiceToPdf.vue'),
  },
  {
    path: '/',
    component: () => import(/* webpackChunkName: "dashboard" */ '../views/dashboard/Dashboard.vue'),
    redirect: '/orders/treatment',
    children: [
      {
        path: '/orders/:orderType',
        name: 'orders',
        component: () => import(/* webpackChunkName: "orders" */ '../views/dashboard/Orders.vue'),
      },
      {
        path: '/orders/:orderType/:id',
        name: 'order',
        component: () => import(/* webpackChunkName: "order" */ '../views/dashboard/Order.vue'),
      },
      {
        path: '/invoices',
        name: 'invoices',
        component: () => import(/* webpackChunkName: "invoices" */ '../views/dashboard/Invoices.vue'),
      },
      {
        path: '/invoices/:id',
        name: 'invoice',
        component: () => import(/* webpackChunkName: "invoice" */ '../views/dashboard/Invoice.vue'),
      },
      {
        path: '/stock',
        name: 'stock',
        component: () => import(/* webpackChunkName: "stock" */ '../views/dashboard/Stock.vue'),
      },
      {
        path: '/transactions',
        name: 'transactions',
        component: () => import(/* webpackChunkName: "transactions" */ '../views/dashboard/Transactions.vue'),
      },
      {
        path: '/warehouses',
        name: 'warehouses',
        component: () => import(/* webpackChunkName: "warehouses" */ '../views/dashboard/Warehouses.vue'),
      },
      {
        path: '/warehouses/:id',
        name: 'warehouse',
        component: () => import(/* webpackChunkName: "warehouse" */ '../views/dashboard/Warehouse.vue'),
      },
      {
        path: '/packages',
        name: 'packages',
        component: () => import(/* webpackChunkName: "packages" */ '../views/dashboard/Packages.vue'),
      },
      {
        path: '/packages/:id',
        name: 'package',
        component: () => import(/* webpackChunkName: "package" */ '../views/dashboard/Package.vue'),
      },
      {
        path: '/vessels',
        name: 'vessels',
        component: () => import(/* webpackChunkName: "vessels" */ '../views/dashboard/Vessels.vue'),
      },
      {
        path: '/vessels/:id',
        name: 'vessel',
        component: () => import(/* webpackChunkName: "vessel" */ '../views/dashboard/Vessel.vue'),
      },
      {
        path: '/products/:productType',
        name: 'products',
        component: () => import(/* webpackChunkName: "products" */ '../views/dashboard/Products.vue'),
      },
      {
        path: '/products/:productType/:id',
        name: 'product',
        component: () => import(/* webpackChunkName: "product" */ '../views/dashboard/Product.vue'),
      },
      {
        path: '/logs',
        name: 'logs',
        component: () => import(/* webpackChunkName: "logs" */ '../views/dashboard/Logs.vue'),
      },
      {
        path: '/reports',
        name: 'reports',
        component: () => import(/* webpackChunkName: "reports" */ '../views/dashboard/Reports.vue'),
      },
      {
        path: '/locations/:locationType',
        name: 'locations',
        component: () => import(/* webpackChunkName: "locations" */ '../views/dashboard/Locations.vue'),
      },
      {
        path: '/locations/:locationType/:locationId',
        name: 'location',
        component: () => import(/* webpackChunkName: "location" */ '../views/dashboard/Location.vue'),
      },
      {
        path: '/product-types',
        name: 'product-types',
        component: () => import(/* webpackChunkName: "product-types" */ '../views/dashboard/ProductTypes.vue'),
      },
      {
        path: '/product-types/:id',
        name: 'product-type',
        component: () => import(/* webpackChunkName: "product-type" */ '../views/dashboard/ProductType.vue'),
      },
      {
        path: '/companies',
        name: 'companies',
        component: () => import(/* webpackChunkName: "companies" */ '../views/dashboard/Companies.vue'),
      },
      {
        path: '/companies/:id',
        name: 'company',
        component: () => import(/* webpackChunkName: "company" */ '../views/dashboard/Company.vue'),
      },
      {
        path: '/regions',
        name: 'regions',
        component: () => import(/* webpackChunkName: "regions" */ '../views/dashboard/Regions.vue'),
      },
      {
        path: '/regions/:id',
        name: 'region',
        component: () => import(/* webpackChunkName: "region" */ '../views/dashboard/Region.vue'),
      },
      {
        path: '/treatment-categories',
        name: 'treatment-categories',
        component: () => import(/* webpackChunkName: "treatment-categories" */ '../views/dashboard/TreatmentCategories.vue'),
      },
      {
        path: '/treatment-categories/:id',
        name: 'treatment-category',
        component: () => import(/* webpackChunkName: "treatment-category" */ '../views/dashboard/TreatmentCategory.vue'),
      },
      {
        path: '/currency-rates',
        name: 'currency-rates',
        component: () => import(/* webpackChunkName: "currency-rates" */ '../views/dashboard/CurrencyRates.vue'),
      },
      {
        path: '/currency-rates/:id',
        name: 'currency-rate',
        component: () => import(/* webpackChunkName: "currency-rate" */ '../views/dashboard/CurrencyRate.vue'),
      },
      {
        path: '/users/:groupCode',
        name: 'users',
        component: () => import(/* webpackChunkName: "users" */ '../views/dashboard/Users.vue'),
      },
      {
        path: '/users/:groupCode/:id',
        name: 'user',
        component: () => import(/* webpackChunkName: "user" */ '../views/dashboard/User.vue'),
      },
      {
        path: '/profile',
        name: 'profile',
        component: () => import(/* webpackChunkName: "profile" */ '../views/dashboard/Profile.vue'),
      },
    ],
  },
  {
    path: '/login',
    name: 'login',
    component: () => import(/* webpackChunkName: "login" */ '../views/Login.vue'),
  },
];

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
});

router.afterEach(() => {
  store.commit('navbar/isNavbarVisible', true);
});

export default router;
